import React from "react";
import Header from "../Header";
import NavBar from "../navbar";
import Footer from "../Footer";
import Lower from "../Lower";

export default function PeoplePage() {
  const team = [
    {
      name: "Ravinder Kumar Gupta",
      category: "Advisory Board Director",
      role: "Director",
      image: "/images/people/ravi.jpg"
    },
    {
      name: "Deepak Gupta",
      category: "Advisory Board Director",
      role: "Director",
      image: "/images/people/deepak.jpg"
    },
    {
      name: "Shiv Naresh Shivhare",
      category: "Advisory Board",
      role: "Managing Editor – Journals",
      image: "/images/people/naresh.jpg"
    },
    {
      name: "Aditya Khamparia",
      category: "Advisory Board",
      role: "Managing – Conferences",
      image: "/images/people/aditya.jpg"
    },
    // {
    //   name: "Aviral",
    //   category: "Advisory Board",
    //   role: "Assistant – IT",
    //   image: "/images/people/airal.jpg"
    // },
    {
      name: "Harsh Raj",
      category: "Advisory Board",
      role: "Assistant – Media",
      image: "/images/people/harsh.jpg"
    }
  ];

  const advisoryBoardDirectors = team.filter(
    person => person.category === "Advisory Board Director"
  );

  const advisoryBoard = team.filter(
    person => person.category === "Advisory Board"
  );

  return (
    <>
      <Header />
      <NavBar />

      <div className="people-wrapper">
        <h1 className="page-title">People</h1>

        <h2 className="section-title">Advisory Board Director</h2>
        <div className="people-grid">
          {advisoryBoardDirectors.map((person, index) => (
            <div className="person-card" key={index}>
              <img
                src={person.image}
                alt={person.name}
                className="person-image"
                onError={(e) => {
                  e.target.src = "/images/people/default.jpg";
                }}
              />
              <h3 className="person-name">{person.name}</h3>
              <p className="person-role">{person.role}</p>
            </div>
          ))}
        </div>

        <h2 className="section-title">Advisory Board</h2>
        <div className="people-grid">
          {advisoryBoard.map((person, index) => (
            <div className="person-card" key={index}>
              <img
                src={person.image}
                alt={person.name}
                className="person-image"
                onError={(e) => {
                  e.target.src = "/images/people/default.jpg";
                }}
              />
              <h3 className="person-name">{person.name}</h3>
              <p className="person-role">{person.role}</p>
            </div>
          ))}
        </div>

        <style>{`
          .people-wrapper {
            padding: 40px 20px;
            max-width: 1200px;
            margin: 0 auto;
            font-family: Arial, sans-serif;
          }

          .page-title {
            text-align: center;
            margin-bottom: 40px;
            font-size: 32px;
            font-weight: 700;
          }

          .section-title {
            margin: 40px 0 20px;
            font-size: 24px;
            font-weight: 600;
            text-align: center;
          }

          .people-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 24px;
          }

          .person-card {
            background: #ffffff;
            border-radius: 12px;
            padding: 24px 20px;
            text-align: center;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .person-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
          }

          .person-image {
            width: 100px;
            height: 100px;
            object-fit: cover;
            object-position: top;
            border-radius: 50%;
            margin-bottom: 16px;
          }

          .person-name {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 8px;
          }

          .person-role {
            font-size: 14px;
            color: #555555;
          }

          @media (max-width: 600px) {
            .page-title {
              font-size: 26px;
            }
            .section-title {
              font-size: 20px;
            }
          }
        `}</style>
      </div>

      <Lower />
      <Footer />
    </>
  );
}
